"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Sizes = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _sizeModule = _interopRequireDefault(require("./size.module.scss"));
var _sizeContext = require("./sizeContext");
var _sizeOptionHelpers = require("./sizeOptionHelpers");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var propTypes = {
  /** Sizes to be displayed within the list */
  children: _propTypes.default.node.isRequired,
  /** Name of the group */
  label: _propTypes.default.string,
  /** Name of the sub label */
  sublabel: _propTypes.default.string,
  /** Name of the size inputs */
  name: _propTypes.default.string,
  /** Function to be called when a size is selected */
  onClick: _propTypes.default.func,
  /** Flag to hide the label  */
  hideLabel: _propTypes.default.bool,
  /** Custom class name */
  className: _propTypes.default.string,
  /** Name of the selected size variant */
  selectedLabel: _propTypes.default.string,
  /** Specifies the heading level to use for the label */
  headingLevel: _propTypes.default.oneOf(['h2', 'h3', 'h4', 'h5', 'h6'])
};
var Sizes = exports.Sizes = function Sizes(_ref) {
  var children = _ref.children,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'size' : _ref$name,
    _ref$sublabel = _ref.sublabel,
    sublabel = _ref$sublabel === void 0 ? '' : _ref$sublabel,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Size' : _ref$label,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? false : _ref$hideLabel,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    longestLabel = _ref.longestLabel,
    selectedLabel = _ref.selectedLabel,
    containerClassName = _ref.containerClassName,
    _ref$containerProps = _ref.containerProps,
    containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? '' : _ref$brand,
    _ref$hasDiorPromosEna = _ref.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _ref$hasDiorPromosEna === void 0 ? false : _ref$hasDiorPromosEna,
    _ref$headingLevel = _ref.headingLevel,
    Heading = _ref$headingLevel === void 0 ? 'h4' : _ref$headingLevel;
  var renderedLabel = selectedLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectorLabel, {
    headingLevel: Heading,
    label: label,
    selectedLabel: selectedLabel,
    sublabel: sublabel
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(Heading, {
    className: _sizeModule.default['c-sizeList__title'],
    "data-testid": "sizelist:label",
    children: label
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({
    className: (0, _classnames.default)(_sizeModule.default['c-sizeList'], containerClassName)
  }, containerProps), {}, {
    "data-jlds": true,
    children: [hideLabel ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: renderedLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "".concat(_sizeModule.default["c-sizeList__items"], " ").concat(className),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_sizeContext.SizeProvider, {
        value: {
          name: name,
          onClick: onClick,
          longestLabel: longestLabel,
          brand: brand,
          hasDiorPromosEnabled: hasDiorPromosEnabled
        },
        children: children
      })
    })]
  }));
};
var SizeList = function SizeList(_ref2) {
  var brand = _ref2.brand,
    _ref2$hasDiorPromosEn = _ref2.hasDiorPromosEnabled,
    hasDiorPromosEnabled = _ref2$hasDiorPromosEn === void 0 ? false : _ref2$hasDiorPromosEn,
    children = _ref2.children,
    _ref2$buttonSizeThres = _ref2.buttonSizeThresholds,
    buttonSizeThresholds = _ref2$buttonSizeThres === void 0 ? _sizeOptionHelpers.defaultThresholds : _ref2$buttonSizeThres,
    _ref2$onClick = _ref2.onClick,
    onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? 'size' : _ref2$name,
    label = _ref2.label,
    sublabel = _ref2.sublabel,
    hideLabel = _ref2.hideLabel,
    selectedLabel = _ref2.selectedLabel,
    containerClassName = _ref2.containerClassName,
    _ref2$containerProps = _ref2.containerProps,
    containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
    headingLevel = _ref2.headingLevel;
  if (_react.Children.count(children) === 0) {
    return null;
  }
  var longestLabel = (0, _sizeOptionHelpers.getSizeCategory)(_react.Children.map(children, function (child) {
    return child.props.children;
  }), buttonSizeThresholds);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Sizes, {
    brand: brand,
    containerClassName: containerClassName,
    containerProps: containerProps,
    "data-jlds": true,
    hasDiorPromosEnabled: hasDiorPromosEnabled,
    headingLevel: headingLevel,
    hideLabel: hideLabel,
    label: label,
    longestLabel: longestLabel,
    name: name,
    onClick: onClick,
    selectedLabel: selectedLabel,
    sublabel: sublabel,
    children: children
  });
};
SizeList.propTypes = {
  /** Sizes to be displayed within the list */
  children: _propTypes.default.node.isRequired,
  /** Name of the size inputs */
  name: _propTypes.default.string,
  /** Name of the sublabel */
  sublabel: _propTypes.default.string,
  /** Function to be called when a size is selected */
  onClick: _propTypes.default.func,
  /*
   * Using the length of longest label available we decide against these threshold
   * to categorise it as "small", "medium" or "large".
   */
  buttonSizeThresholds: _propTypes.default.shape({
    small: _propTypes.default.number,
    medium: _propTypes.default.number,
    large: _propTypes.default.number
  }),
  /** Name of the selected size variant */
  selectedLabel: _propTypes.default.string,
  /** Specifies the heading level to use for the label */
  headingLevel: _propTypes.default.oneOf(['h2', 'h3', 'h4', 'h5', 'h6'])
};
var SelectorLabel = function SelectorLabel(_ref3) {
  var _ref3$label = _ref3.label,
    label = _ref3$label === void 0 ? 'Size' : _ref3$label,
    _ref3$headingLevel = _ref3.headingLevel,
    Heading = _ref3$headingLevel === void 0 ? 'h4' : _ref3$headingLevel,
    _ref3$sublabel = _ref3.sublabel,
    sublabel = _ref3$sublabel === void 0 ? '' : _ref3$sublabel,
    selectedLabel = _ref3.selectedLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Heading, {
    className: _sizeModule.default['c-sizeList__title'],
    "data-jlds": true,
    "data-testid": "sizelist:label",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _sizeModule.default['c-sizeList__label'],
      children: "".concat(label, ": ")
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: _sizeModule.default['c-sizeList__selected'],
      children: selectedLabel
    }), sublabel && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: _sizeModule.default['c-sizeList__subLabel'],
      children: [" ", sublabel]
    })]
  });
};
SelectorLabel.propTypes = {
  /** Name of the label */
  label: _propTypes.default.string,
  /** Name of the sublabel */
  sublabel: _propTypes.default.string,
  /** Name of the selected value */
  selectedLabel: _propTypes.default.string.isRequired,
  /** Specifies the heading level to use for the label */
  headingLevel: _propTypes.default.oneOf(['h2', 'h3', 'h4', 'h5', 'h6'])
};
Sizes.propTypes = propTypes;
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(SizeList);